import { useState } from 'react';
import { Row, Col, Descriptions, Button, Typography, Form, Checkbox, Input, DatePicker, Space } from 'antd';
import NewStatementView from './NewStatementView';
import NewStatementStatus from './NewStatementStatus';


const { Title } = Typography;

export default function StepCreating({
  reportingCycles,
  form,
  newFurnishingStatements,
  triggerActionsRender,
  accountId,
  productId,
  userId,
  generateStatements,
}) {
  const rowStyle = { border: '1px solid #ccc', textAlign: 'center', padding: '6px' };
  const wrapperCol = { span: 24 };

  const [isReviewed, setIsReviewed] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const initiateGeneration = (statementsToGenerate, shouldPersistVal = null) => {
    setIsLoading(true);

    const statements = statementsToGenerate?.length > 0 ? statementsToGenerate : form.getFieldValue('statements');
    const shouldPersist = shouldPersistVal !== null ? shouldPersistVal : isReviewed;

    const promises = [];

    statements.forEach((statement) => {
      promises.push(generateStatements({
        avaUserId: userId,
        reportingCycle: statement.reportingCycle,
        productId,
        isClosed: statement.isClosed,
        statementId: statement.statementId,
        statementTs: `${statement.statementDate.format('YYYY-MM-DD')}T00:00:00.000Z`,
        bloomAccountId: accountId,
        shouldPersist
      }));
    });
    setIsReviewed(true);

    Promise.all(promises).finally(() => {
      setIsLoading(false);
    });
  }

  const revertReview = () => {
    setIsReviewed(false);
  }

  const onFinish = (data) => {
    console.log('newStatements', data);
  }

  const onFinishFailed = (data) => {
    console.log('newStatements', data);
  }

  return <>
    <Title type="secondary" underline level={3} style={{ textAlign: 'center' }}>
      Create Statements
    </Title>
    <Form
        name="basic"
        labelCol={{
          span: 8,
        }}
        wrapperCol={{
          span: 16,
        }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
        form={form}
      >
        <Form.List name="statements">
          {(fields) => <>
            {fields.map(({ key, name, ...restField }) => <>
              <Row
                key={key}
                justify="space-evenly"
                style={rowStyle}>
                <Col span={20}>
                  { !isReviewed && <Descriptions layout="vertical" bordered column={5} size="small">
                    <Descriptions.Item label="Closing Statement?">
                      <Form.Item
                          {...restField}
                          name={[name, "isClosed"]}
                          wrapperCol={24}
                          valuePropName="checked"
                          disabled={form.getFieldValue('statements')[key]?.isClosedDisabled}
                          >
                          <Checkbox />
                        </Form.Item>
                    </Descriptions.Item>
                    <Descriptions.Item label="Statement ID" span={2}>
                      <Form.Item
                        {...restField}
                        name={[name, "statementId"]}
                        wrapperCol={wrapperCol}
                        rules={[
                            {
                            required: true,
                            message: 'Please enter a Statement ID',
                            },
                            {
                              regex: /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i,
                              message: 'Please enter a valid ID'
                            }
                        ]}
                        extra={<small>Statement ID</small>}
                        >
                        <Input />
                      </Form.Item>
                    </Descriptions.Item>
                    <Descriptions.Item label="Statement Date" span={2}>
                      <Form.Item
                        {...restField}
                        name={[name, "statementDate"]}
                        wrapperCol={wrapperCol}
                        rules={[
                            {
                            required: true,
                            message: 'Please enter Statement Date',
                            },
                        ]}
                        extra={<small>Statement Date</small>}
                        >
                        <DatePicker format="YYYY-MM-DD"/>
                      </Form.Item>
                    </Descriptions.Item>
                  </Descriptions> }
                  {
                    isReviewed && 
                      <NewStatementView
                        status={reportingCycles?.[form.getFieldValue('statements')[key]?.reportingCycle]}
                        initiateGeneration={initiateGeneration}
                        statement={form.getFieldValue('statements')[key]}
                        />
                  }
                </Col>
                <Col span={4}>
                  <Descriptions layout="vertical" bordered column={2} size="small">
                    <Descriptions.Item label="Reporting Cycle" span={2}>
                      { form.getFieldValue('statements')[key]?.reportingCycle }
                    </Descriptions.Item>
                    <Descriptions.Item label="Status">
                      <Space direction="vertical">
                        {isReviewed && <NewStatementStatus
                          statusObj={
                            reportingCycles?.[form.getFieldValue('statements')[key].reportingCycle]
                          }
                          />}
                      </Space>
                    </Descriptions.Item>
                  </Descriptions>
                </Col>
              </Row>
            </>
          )}
        </>}
      </Form.List>
      <Form.Item shouldUpdate={true} wrapperCol="24">
        {() => {
          triggerActionsRender();
        }}
      </Form.Item>
    </Form>

    {
      newFurnishingStatements?.length > 0
      && <Row>
        <Col span="2" offset="18">
          {isReviewed && <Button
            danger
            onClick={revertReview}
            block
            disabled={isLoading}
          >
            Back
          </Button>
          }
        </Col>
        <Col span="4">
          <Button
            onClick={initiateGeneration}
            block
            loading={isLoading}
            type="primary"
          >
            {!isReviewed ? "Review" : "Create Statements"}
          </Button>
          </Col>
      </Row>
    }
    {/* {newStatements && <>
      <Space direction="vertical" style={{ width: '100%' }}>
        {newStatements.map((statement, index) => (
          <Row key={index} bordered>
            <Col span={4}>
              <Descriptions layout="vertical" bordered column={1} size="small">
                <Descriptions.Item label="Reporting Cycle" span={2}>
                  {statement.reportingCycle}
                </Descriptions.Item>
              </Descriptions>
            </Col>
            <Col span={20}>
              <Space direction="vertical" style={{ width: '100%' }}>
                
              </Space>
            </Col>
          </Row>
        ))}
      </Space>
    </>} */}
  </>
}